import type { BreakpointsConfigProps } from '@ui/breakpoints/breakpoints.types';

export const breakpointsConfig = {
    width: {
        xxs: { value: 0, comparator: '>=' } as const,
        xs: { value: 360, comparator: '>=' } as const,
        s: { value: 576, comparator: '>=' } as const,
        m: { value: 768, comparator: '>=' } as const,
        l: { value: 992, comparator: '>=' } as const,
        xl: { value: 1200, comparator: '>=' } as const,
        xxl: { value: 1400, comparator: '>=' } as const,
        xxxl: { value: 1536, comparator: '>=' } as const,
    },
    height: {
        xxs: { value: 0, comparator: '>=' } as const,
        xs: { value: 360, comparator: '>=' } as const,
        s: { value: 576, comparator: '>=' } as const,
        m: { value: 768, comparator: '>=' } as const,
        l: { value: 992, comparator: '>=' } as const,
        xl: { value: 1200, comparator: '>=' } as const,
        xxl: { value: 1400, comparator: '>=' } as const,
        xxxl: { value: 1536, comparator: '>=' } as const,
    },
} satisfies BreakpointsConfigProps;
